export default __webpack_public_path__ + "static/media/parking-fee-loitering-info.0b12d80e.png";